import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=0c00fde2&"
import script from "./roleList.vue?vue&type=script&lang=js&"
export * from "./roleList.vue?vue&type=script&lang=js&"
import style0 from "./roleList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports